export default "__VITE_ASSET__mWzvBKqR__"